export const PAGINATION_SELECTION_VALUES = [100, 200, 300, 400, 500];
export const ALL_ACTIONED_BY_USERS = "All Actioned By Users";
export const ALL_UPDATE_TYPES_RACI = ["All Update Types", "RACI Update", "RACI Creation", "RACI Deletion"];
export const ALL_UPDATE_TYPES_PROCESS = ["All Update Types", "Process Attribute Update", "Process Attribute Value Update"];
export const CHANGE_LOG_TYPE_PROCESS = "Process";
export const CHANGE_LOG_TYPE_RACI = "RACI";
export const CHANGE_LOG_TYPES = [CHANGE_LOG_TYPE_RACI, CHANGE_LOG_TYPE_PROCESS];
export const PEOPLE_PORTAL_SYNC_ALIAS = "PeoplePortal Sync";